import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import UsePagination from './UsePagination';
import ClientProvider from './client';
export default createDemo(import.meta.url, UsePagination, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/material/components/pagination/demos/use/UsePagination.tsx",
    "fileName": "UsePagination.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import * as React from 'react';\nimport usePagination from '@mui/material/usePagination';\nimport { styled } from '@mui/material/styles';\n\nconst count = 10;\n\nconst List = styled('ul')({\n  listStyle: 'none',\n  padding: 0,\n  margin: 0,\n  display: 'flex',\n});\n\nexport default function UsePagination() {\n  const firstPageRef = React.useRef<HTMLButtonElement>(null);\n  const lastPageRef = React.useRef<HTMLButtonElement>(null);\n\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus-unfocused",
            "dataFrameIndent": 0,
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "  const { items } = usePagination({\n    count,\n  });\n\n  return (\n    <nav>\n      <List>\n        {items.map(({ page, type, selected, onClick, ...item }, index) => {\n          let children = null;\n\n          if (type === 'start-ellipsis' || type === 'end-ellipsis') {\n            children = '…';\n          } else if (type === 'page') {\n            let pageRef;\n\n            if (page === 1) {\n              pageRef = firstPageRef;\n            } else if (page === count) {\n              pageRef = lastPageRef;\n            }\n\n            children = (\n              <button\n                type=\"button\"\n                ref={pageRef}\n                style={{\n                  fontWeight: selected ? 'bold' : undefined,\n                }}\n                {...item}\n                onClick={onClick}\n              >\n                {page}\n              </button>\n            );\n          } else {\n            children = (\n              <button\n                type=\"button\"\n                {...item}\n                onClick={(event) => {\n                  let focusTarget: typeof firstPageRef | undefined;\n\n                  if (type === 'previous' && page === 1) {\n                    focusTarget = firstPageRef;\n                  } else if (type === 'next' && page === count) {\n                    focusTarget = lastPageRef;\n                  }\n\n                  const shouldMoveFocus =\n                    event.currentTarget.ownerDocument.activeElement ===\n                    event.currentTarget;\n\n                  onClick(event);\n\n                  if (shouldMoveFocus) {\n                    focusTarget?.current?.focus();\n                  }\n                }}\n              >\n                {type}\n              </button>\n            );\n          }\n\n          return <li key={index}>{children}</li>;\n        })}\n      </List>\n    </nav>\n  );\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 87,
        "focusedLines": 0,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import * as React from 'react';\nimport usePagination from '@mui/material/usePagination';\nimport { styled } from '@mui/material/styles';\n\nconst count = 10;\n\nconst List = styled('ul')({\n  listStyle: 'none',\n  padding: 0,\n  margin: 0,\n  display: 'flex',\n});\n\nexport default function UsePagination() {\n  const firstPageRef = React.useRef<HTMLButtonElement>(null);\n  const lastPageRef = React.useRef<HTMLButtonElement>(null);\n\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus-unfocused",
          "dataFrameIndent": 0
        },
        "  const { items } = usePagination({\n    count,\n  });\n\n  return (\n    <nav>\n      <List>\n        {items.map(({ page, type, selected, onClick, ...item }, index) => {\n          let children = null;\n\n          if (type === 'start-ellipsis' || type === 'end-ellipsis') {\n            children = '…';\n          } else if (type === 'page') {\n            let pageRef;\n\n            if (page === 1) {\n              pageRef = firstPageRef;\n            } else if (page === count) {\n              pageRef = lastPageRef;\n            }\n\n            children = (\n              <button\n                type=\"button\"\n                ref={pageRef}\n                style={{\n                  fontWeight: selected ? 'bold' : undefined,\n                }}\n                {...item}\n                onClick={onClick}\n              >\n                {page}\n              </button>\n            );\n          } else {\n            children = (\n              <button\n                type=\"button\"\n                {...item}\n                onClick={(event) => {\n                  let focusTarget: typeof firstPageRef | undefined;\n\n                  if (type === 'previous' && page === 1) {\n                    focusTarget = firstPageRef;\n                  } else if (type === 'next' && page === count) {\n                    focusTarget = lastPageRef;\n                  }\n\n                  const shouldMoveFocus =\n                    event.currentTarget.ownerDocument.activeElement ===\n                    event.currentTarget;\n\n                  onClick(event);\n\n                  if (shouldMoveFocus) {\n                    focusTarget?.current?.focus();\n                  }\n                }}\n              >\n                {type}\n              </button>\n            );\n          }\n\n          return <li key={index}>{children}</li>;\n        })}\n      </List>\n    </nav>\n  );\n"
      ],
      [
        "span",
        "frame",
        "}\n"
      ]
    ],
    "totalLines": 87,
    "focusedLines": 0,
    "collapsible": true,
    "externals": [
      "react",
      "@mui/material/usePagination",
      "@mui/material/styles"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
